// ../../data/useConvertQuoteToLead.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";

export type QuoteAcceptedAs     = "Collection" | "DropOff";
export type QuotePriceSelection = "Collection" | "DropOff"    | "Amended";

export default function useConvertQuoteToLead(quoteId: string) {
  const { post } = useApiHelper();
  const queryClient = useQueryClient();

  const convert = useMutation(
    ({acceptedAs, choice, assignedCustomerId}: {acceptedAs: QuoteAcceptedAs, choice: QuotePriceSelection, assignedCustomerId: string | null}) =>
      post(`/lead/from/quote/${quoteId}`, {
        acceptedAs: acceptedAs === "Collection" ? 1 : acceptedAs === "DropOff" ? 2 : 0,
        priceSelection: choice === "Collection" ? 0 : choice === "DropOff" ? 1 : 2,
        assignedCustomerId: assignedCustomerId, // can be null
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["quote", quoteId]);
        queryClient.invalidateQueries(["leads"]);
      },
    }
  );

  return { convert };
}